import React, { useEffect } from 'react';
import { useModal } from '../common/context/ModalProvider';
import { Dialog, DialogContent } from './ui/dialog';
import { useDialog } from '../common/hooks/useDialog';

const DialogContainer = () => {
  const { isDialogOpen, dialogContent } = useDialog();

  useEffect(() => {}, [isDialogOpen]);

  if (!isDialogOpen) return null;

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent className='flex aspect-square w-[96vw] flex-col items-center justify-center border-transparent bg-transparent'>
        {dialogContent.content}
      </DialogContent>
    </Dialog>
  );
};

export default DialogContainer;
